var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveysMobiIcon = function SvgSurveysMobiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.54 3.318a1.57 1.57 0 0 1 0 2.222L16.826 21.254a1.57 1.57 0 0 1-2.223 0L9.89 16.54a1.571 1.571 0 1 1 2.222-2.222l3.603 3.603L30.317 3.318a1.57 1.57 0 0 1 2.223 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.667 4.177c-.412 0-.808.17-1.1.47s-.456.708-.456 1.133v22.44c0 .425.164.833.456 1.134s.688.47 1.1.47h21.78c.413 0 .808-.17 1.1-.47.292-.301.456-.709.456-1.134V17c0-.885.696-1.603 1.556-1.603.859 0 1.555.718 1.555 1.603v11.22a4.88 4.88 0 0 1-1.367 3.4 4.6 4.6 0 0 1-3.3 1.409H4.667a4.6 4.6 0 0 1-3.3-1.409A4.88 4.88 0 0 1 0 28.22V5.78c0-1.275.492-2.498 1.367-3.4a4.6 4.6 0 0 1 3.3-1.408H21.78c.86 0 1.556.717 1.556 1.603 0 .885-.697 1.602-1.556 1.602z",
    clipRule: "evenodd"
  })));
};
export default SvgSurveysMobiIcon;